// import { EntityApiService } from '@dfl/react-security';
import { ApiClientService, RequestConfig, SearchResponseType } from '@dfl/react-security';
import { IEstablishment } from 'modules/client/establishment/interfaces';
import EntityApiServicePopulate from 'utils/EntityApiServicePopulate';
import { EstablishmentInfoPayload } from '../interfaces/establishment-section-payload.types';

class EstablishmentService extends EntityApiServicePopulate<IEstablishment> {
  updateInfo = (_id: string, params: EstablishmentInfoPayload, config?: RequestConfig) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${_id}`), params, config));
  };

  searchAllPopulated = (
    params?: any,
    config?: RequestConfig | undefined,
  ): Promise<SearchResponseType<IEstablishment>> => {
    params.size = 200;
    params.populate = true;
    return this.search(params, config);
  };
}

export default new EstablishmentService('/ms-auth/api/space');
